/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_ResultInputs */

const en_cna_field_result = /** @type {(inputs: Cna_Field_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const ja_cna_field_result = /** @type {(inputs: Cna_Field_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果`)
};

const fr_cna_field_result = /** @type {(inputs: Cna_Field_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultat`)
};

const de_cna_field_result = /** @type {(inputs: Cna_Field_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis`)
};

/**
* | output |
* | --- |
* | "Result" |
*
* @param {Cna_Field_ResultInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_result = /** @type {((inputs?: Cna_Field_ResultInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_ResultInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_result(inputs)
	if (locale === "ja") return ja_cna_field_result(inputs)
	if (locale === "fr") return fr_cna_field_result(inputs)
	return de_cna_field_result(inputs)
});